export { default as PartSearchPage } from "./PartSearchPage.vue";
